import React from 'react';
import DayCell from './DayCell';

const SlotPicker = ({ selectedDays, checkIsEmpty, buyerSchedules, setActiveDate}) => {
  return (
    <div className="day-cells">
          {!selectedDays.length ? (
              <div className={'day-cell day-cell--empty day-cell--active'}>
                  No Date Selected
          </div>
          ) : selectedDays.map(el => <DayCell key={el} value={el} buyerSchedules={buyerSchedules} checkIsEmpty={(day, IsCheckInCurrentDay) => checkIsEmpty(day, IsCheckInCurrentDay)} setActiveDate={(activeDay) => setActiveDate(activeDay)}/>)
      }
    </div>
  );
}

export default SlotPicker;